import type { SliderSettings } from "react-slick";

/** Auto-scrolling hero carousel. */
export const HERO_SETTINGS: SliderSettings = {
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 1500,
  autoplaySpeed: 3500,
  arrows: false,
};

/** Popular-categories carousel (mobile only). */
export const POPULAR_CATEGORIES_SETTINGS: SliderSettings = {
  slidesToShow: 3,
  slidesToScroll: 1,
  className: "center",
  centerPadding: "10px",
  centerMode: true,
  responsive: [
    { breakpoint: 700, settings: { slidesToShow: 2 } },
    { breakpoint: 500, settings: { slidesToShow: 1 } },
  ],
};

/** "Up Next" carousel on the course detail screen. */
export const UP_NEXT_SETTINGS: SliderSettings = {
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: true,
  infinite: false,
  dots: false,
  responsive: [
    { breakpoint: 700, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

/** Most-viewed-videos carousel. */
export const MOST_VIEWED_SETTINGS: SliderSettings = {
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  centerPadding: "150px",
  dots: true,
  responsive: [
    { breakpoint: 700, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};
